import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, BookOpenIcon } from 'lucide-react';
import { tomos, tomoIncludes } from '../data/content';
export function TomosSection() {
  const [active, setActive] = useState(0);
  const tomo = tomos[active];
  return <section className="w-full bg-ink-950 py-20" aria-labelledby="tomos" data-id="element-218" data-mp="1u2n888r8efaa">
      <div className="mx-auto w-full max-w-6xl px-4 sm:px-6" data-id="element-219" data-mp="1u4rbcohb3a9i">
        <p className="font-display text-[11px] font-700 uppercase tracking-[0.28em] text-gold" data-id="element-220" data-mp="xdflwyisg25b">
          El Código Solar 360°
        </p>
        <h2 id="tomos" className="mt-3 max-w-3xl font-display text-3xl font-900 leading-tight text-white sm:text-4xl" data-id="element-221" data-mp="11g2besrzlazc">
          5 Tomos + 5 Bonos — de no entender nada a decidir con criterio propio
        </h2>

        <div className="mt-10 grid gap-8 lg:grid-cols-[0.9fr_1.1fr] lg:items-start" data-id="element-222" data-mp="2ht0utjr1rlxh">
          <div role="tablist" aria-label="Tomos del sistema" className="flex flex-col gap-1.5" data-id="element-223" data-mp="2mr2fua819vbl">
            {tomos.map((item, index) => {
            const isActive = index === active;
            return <button key={item.id} role="tab" id={`tab-${item.id}`} aria-selected={isActive} aria-controls={`panel-${item.id}`} onClick={() => setActive(index)} className={`flex items-center justify-between rounded-lg border px-4 py-3 text-left transition-colors duration-150 ease-smooth ${isActive ? 'border-gold bg-ink-800 text-white' : 'border-ink-800 bg-ink-900 text-slate-400 hover:border-ink-600 hover:text-slate-200'}`} data-id="element-224" data-mp="2mmdmiq9vzza5" data-mpi={index}>
                  <span className="font-display text-sm font-700 uppercase tracking-wide" data-id="element-225" data-mp="1tw50uog56wqt">
                    {item.tab}
                  </span>
                  <span className="ml-4 truncate text-xs text-slate-500" data-id="element-226" data-mp="1k0ti7v1m55ds">
                    {item.kicker.split('· ')[1]}
                  </span>
                </button>;
          })}
          </div>

          <motion.div key={tomo.id} role="tabpanel" id={`panel-${tomo.id}`} aria-labelledby={`tab-${tomo.id}`} initial={{
          opacity: 0,
          y: 8
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.22,
          ease: [0.23, 1, 0.32, 1]
        }} className="rounded-2xl border border-ink-700 bg-ink-900 p-7 shadow-panel sm:p-9" data-id="element-227" data-mp="1fc2c0v42vf6v">
            <span className="inline-flex h-11 w-11 items-center justify-center rounded-lg bg-ink-800 text-gold" data-id="element-228" data-mp="1y3v1ifjxui9u">
              <BookOpenIcon className="h-5 w-5" aria-hidden="true" data-id="element-229" data-mp="1k8j605xyknrv" />
            </span>
            <p className="mt-5 text-xs font-600 uppercase tracking-[0.2em] text-gold" data-id="element-230" data-mp="1o9unfo6oi2oz">
              {tomo.kicker}
            </p>
            <h3 className="mt-2 font-display text-2xl font-800 leading-tight text-white sm:text-3xl" data-id="element-231" data-mp="2gs02jf97np4y">
              {tomo.title}
            </h3>
            <p className="mt-4 text-[15px] leading-relaxed text-slate-300" data-id="element-232" data-mp="5bonggmcb6qg">{tomo.description}</p>
          </motion.div>
        </div>

        <div className="mt-12 rounded-2xl border border-ink-800 bg-ink-900 p-7" data-id="element-233" data-mp="cc07urk3xnc">
          <h3 className="font-display text-sm font-700 uppercase tracking-[0.2em] text-white" data-id="element-234" data-mp="f55ifny7qrvp">
            Cada tomo incluye
          </h3>
          <ul className="mt-5 grid gap-x-8 gap-y-3 sm:grid-cols-2 lg:grid-cols-4" data-id="element-235" data-mp="3ij9lkghundli">
            {tomoIncludes.map(item => <li key={item} className="flex gap-2.5 text-sm leading-relaxed text-slate-300" data-id="element-236" data-mp="3dm00fd1hto3h">
                <CheckIcon className="mt-0.5 h-4 w-4 flex-none text-leaf-400" aria-hidden="true" data-id="element-237" data-mp="3sj0fafyl5okj" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}